<template>
  <div class="container-fluid shadow header">
    <div class="col-4 wht-text pl-0">
      <a href="https://getmxd.com">
        <img src="../assets/mxd-white.svg" style="width: 126px" alt="MXD Logo" /></a>
    </div>
    <div
      class="col-4 site-nav-primary d-xl-flex justify-content-center align-items-center d-lg-flex d-sm-none d-xs-none d-none">
      <ul class="d-flex justify-content-center align-items-center m-0 p-0">
        <li><a href="https://getmxd.com">Overview</a></li>
        <li><a href="/pricing">Pricing</a></li>
        <li><a href="https://getmxd.com/process">Process</a></li>
      </ul>
    </div>
    <div class="col-4 site-nav-right flex-row d-flex text-right p-0 d-flex justify-content-end align-items-center">


      <div>
        <img class="rounded-circle site-logo" src="../assets/avatar.jpg" height="40" width="40" alt="" />
      </div>

      <div class="dropdown show">
        <p class="nav-header btn btn-secondary dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ userDetails }}
        </p>

        <div v-if="loggedIn" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a class="wht-text nav-text dropdown-item" href="https://www.getmxd.com/help" target="_blank">Help</a>
          <router-link class="wht-text nav-text dropdown-item" :to="{ name: 'logout' }">Logout</router-link>
        </div>

        <div v-if="!loggedIn" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <router-link class="wht-text nav-text dropdown-item" :to="{ name: 'login' }">Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.state.apiEvents.jwt != "" ? 1 : 0;
    },
    userDetails() {
      return this.$store.state.apiEvents.username
        ? this.$store.state.apiEvents.username.split("@")[0]
        : "";
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  flex-wrap: nowrap;
  place-content: center;
  align-items: center;
  width: 90%;
  min-height: 160px;
  max-width: 1300px;
}

.site-logo {
  flex: 1 1 0%;
  margin-right: auto;
}

.site-nav-primary {
  flex: 1 1 0%;
}

.site-nav-primary ul li {
  text-decoration: none;
  list-style-type: none;
  margin: 0 20px;
}

.site-nav-primary ul li a {
  display: block;
  font-family: "Astronoma", sans-serif;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 0.9375em;
  letter-spacing: 1.67px;
  border-bottom: 2px solid transparent;
  padding: 12px 0 7px 0;
  -ms-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.site-nav-primary ul li a:hover {
  border-color: #2bfed1;
}

.site-nav-right {
  flex: 1 1 0%;
  margin-left: auto;
}

.nav-header {
  font-size: 15px !important;
  color: rgb(43, 254, 209) !important;
}

.nav-text {
  width: 66px;
  height: 20px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.83px;
}
</style>
